// IELTS Mock 8 — Academic Speaking (advanced difficulty)
// Same shape as IELTS_DATA_SPEAKING in ../IeltsSpeaking.js.
const IELTS_MOCK8_SPEAKING = {
  title: "Academic Speaking Practice Test 8",
  parts: [
    {
      id: "part1",
      title: "Part 1: Introduction & Interview (4-5 min)",
      questions: [
        "Let's talk about maps and directions. Do you have a good sense of direction?",
        "Do you prefer using a paper map or an app when you go somewhere new? Why?",
        "Have you ever got lost? What happened?",
        "Let's talk about noise. Is the area where you live noisy or quiet?",
        "Are there any sounds that you find particularly relaxing?"
      ]
    },
    {
      id: "part2",
      title: "Part 2: Long Turn (Cue Card) (3-4 min)",
      prompt: "Describe a time when you discovered that something you had believed for a long time was not true. You should say: What you used to believe, Why you believed it, How you found out it was wrong, and explain how you felt about discovering the truth.",
      preparationTime: 60,
      speakingTime: 120
    },
    {
      id: "part3",
      title: "Part 3: Discussion (4-5 min)",
      questions: [
        "Why do you think false information often spreads faster than accurate information?",
        "To what extent should ordinary people be expected to evaluate scientific claims for themselves?",
        "Some argue that scientists who admit their mistakes should be praised rather than criticised. How far do you agree?",
        "How has the way people learn traditional knowledge, such as crafts or navigation, changed over the last century?",
        "Is it more important for a society to preserve its traditional skills or to adopt new technology? Can it do both?",
        "Do you think the media has a responsibility to report scientific uncertainty, even if it makes stories less exciting?"
      ]
    }
  ]
};

export default IELTS_MOCK8_SPEAKING;
